import { parse, print } from 'graphql'
import { useQuery } from 'glimmer-apollo'
import { AVAILABILITY_TIME_FRAGMENT } from 'customer-flows/gql/fragments/availability-time'
import { throwClassifiedFetchError } from 'customer-flows/gql/queries/availability-errors'

export type AvailabilityTimesInput = {
  availabilityRequest: AvailabilityTimesRequestInput
}

export type AvailabilityTimesVariables = Omit<AvailabilityTimesRequestInput, 'activityId'>

export type AvailabilityTimesRequestInput = {
  activityId: string
  channelId?: string
  dateRange: string
  resourceOptionQuantities: Array<{
    quantity: number
    resourceOptionId?: string
  }>
}

// There is no `lowPriority` option here any more. It existed for the engine's all-type background
// times family — the only low-priority times request there ever was — and that family is gone (the
// BE answered it with zero results unconditionally). Every remaining times request is the selected
// date's authoritative answer, which the user is waiting on.
export async function fetchAvailabilityTimes(
  context: Object,
  variables: AvailabilityTimesRequestInput
): Promise<any> {
  const availabilityQuery = useQuery<AvailabilityTime, AvailabilityTimesInput>(context, () => [
    query,
    {
      fetchPolicy: 'no-cache', // SO IMPORTANT, availability is HUGE and changes often. Without this the UI lags A LOT
      variables: {
        availabilityRequest: variables
      },
      onError: (error) => throwClassifiedFetchError('Failed to fetch availability', error)
    }
  ])

  return availabilityQuery.refetch()
}

const query = parse(`
  query AvailabilityTimes($availabilityRequest: AvailabilityRequestInput!) {
    availabilityTimes(availabilityRequest: $availabilityRequest) {
      ...AvailabilityTimeFields
    }
  }
  ${print(AVAILABILITY_TIME_FRAGMENT)}
`)
